import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import styles from './ProjectOverviewChart.module.scss';
import classNames from 'classnames/bind';
import { Box, MenuItem, Select, Typography } from '@mui/material';
import { ArrowDownMenuIcon } from '~/assets/icons';
import { useAppDispatch } from '~/redux/hooks';
import { handleDashboardProjectOverview } from '~/thunks/dashboard/dashboard';
const data = [
  { name: "Not started", value: 52, color: "#C9D3E4" },
  { name: "Completed", value: 14, color: "#2DB3FC" },
  { name: "In progress", value: 32, color: "#2D80FC" },
];

const Colors: string[] = ["#C9D3E4", "#2DB3FC", "#2D80FC"]

const renderLegend = (props: any) => {
  const { payload } = props;
  return (
    <ul className="m-0 p-0 list-none flex gap-4">
      {payload.map((entry: any, index: number) => (
        <li
          key={`item-${index}`}
          className="flex items-center mb-4"
        >
          <span
            style={{
              display: "inline-block",
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: entry.payload.color,
              marginRight: 8,
            }}
          />
          <span className='text-white truncate text-[12px]'>
            {entry.value}: {entry.payload.value}
          </span>
        </li>
      ))}
    </ul>
  );
};

const ProjectOverviewChart = () => {
  const cx = classNames.bind(styles);
  const [timeRange, setTimeRange] = useState('Daily');
  const dispatch = useAppDispatch();

  const [chartData, setChartData] = useState<any[]>([])

  const fetchData = () => {
    dispatch(handleDashboardProjectOverview({
      filter: {
        page: 1,
        limit: 20
      }
    })).unwrap()
      .then((reponse: any) => {
        let data = reponse.data;
        let charts: any[] = [];
        data.map((item: any, index: number) => {
          charts.push({
            name: item.status,
            value: item.totalJobs,
            color: Colors[index % 3]
          })
        })

        setChartData(charts);
      })
      .catch((error: any) => {

      })
      .finally(() => {

      });
  }

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Box className={cx("projectOverview")}>
      <Box className='flex items-center justify-between mb-4'>
        <Typography className={cx("title")}>Project overview</Typography>

      </Box>
      <PieChart width={400} height={300}>
        <defs>
          {chartData.map((entry, index) => (
            <pattern
              key={index}
              id={`pattern-${index}`}
              width="12"
              height="12"
              patternTransform="rotate(45)"
              patternUnits="userSpaceOnUse"
            >
              {/* nền lấy từ data.color */}
              <rect width="12" height="12" fill={entry.color} />
              <rect width="0.5" height="12" fill="#FFFFFF" />
            </pattern>
          ))}
        </defs>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          labelLine={false}
          outerRadius={100}
          fill="#8884d8"
          dataKey="value"
          stroke="#071427"
          cornerRadius={6}
          innerRadius={45}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={`url(#pattern-${index})`} />
          ))}
        </Pie>
        <Tooltip />
        <Legend content={renderLegend} />
      </PieChart>
    </Box>
  );
};

export default ProjectOverviewChart;
